// Acanetic editorial design tokens.
// Mirror the Swiss/paper system used in the landing redesign.

export const acaPal = {
  paper:      "#eeeae0",
  paperDeep:  "#e3ded0",
  card:       "#f7f4ec",
  ink:        "#161616",
  inkSoft:    "#5a5751",
  inkMute:    "#8a8472",
  rule:       "#b8b1a0",
  ruleSoft:   "#cfc7b3",
  accent:     "#c24a1e",
  accentSoft: "#e6c1ad",
} as const;

export const acaFont = {
  sans:  "'Inter Tight', 'Neue Haas Grotesk Display Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  mono:  "'JetBrains Mono', ui-monospace, Menlo, monospace",
  serif: "'Source Serif 4', 'Source Serif Pro', Georgia, serif",
} as const;

export const acaMaxWidth = 1280;
